const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ commons
const { formatText } = require('core/i18n').i18n;
// @ components
const { InputSafe } = require('commonsComponents/inputSafe');

class BeneficiaryNewBankDetails extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            name: props.immBeneficiaryNew.get('bankName'),
            address: props.immBeneficiaryNew.get('bankAddress'),
            city: props.immBeneficiaryNew.get('bankCity')
        }

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleBankNameChange = this.handleBankNameChange.bind(this);
        this.handleBankAddressChange = this.handleBankAddressChange.bind(this);
        this.handleBankCityChange = this.handleBankCityChange.bind(this);
        this.handleBankNameBlur = this.handleBankNameBlur.bind(this);
        this.handleBankAddressBlur = this.handleBankAddressBlur.bind(this);
        this.handleBankCityBlur = this.handleBankCityBlur.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const {immBeneficiaryNew} = nextProps;
        const {state, setState} = this;
        const name = immBeneficiaryNew.get('bankName');
        const city = immBeneficiaryNew.get('bankCity');
        const address = immBeneficiaryNew.get('bankAddress');

        if (name !== state.name) {
            setState({
                name
            });
        }

        if (city !== state.city) {
            setState({
                city
            });
        }

        if (address !== state.address) {
            setState({
                address
            });
        }
    }

    handleBankAddressBlur(evt) {
        this.props.actions.setBeneficiaryBankAddress(evt.target.value);
    }

    handleBankAddressChange(evt) {
        this.setState({
            address: evt.target.value
        });
    }

    handleBankCityBlur(evt) {
        this.props.actions.setBeneficiaryBankCity(evt.target.value);
    }

    handleBankCityChange(evt) {
        this.setState({
            city: evt.target.value
        });
    }

    handleBankNameBlur(evt) {
        this.props.actions.setBeneficiaryBankName(evt.target.value);
    }

    handleBankNameChange(evt) {
        this.setState({
            name: evt.target.value
        });
    }

    render() {
        const { immBeneficiaryNew, isEditingScheduled } = this.props;

        const labelName = formatText('transferSummary-step1BeneficiaryBankName');

        const nameRequiredAlertVisible = immBeneficiaryNew.get('bankNameIsDirty') && immBeneficiaryNew.get('bankName') === '';
        const nameRequiredErrorMsg = formatText('transferSummary-requiredMessage',[labelName]);

        const labelAddress = formatText('transferSummary-step1BeneficiaryBankAddress');
        const labelCity = formatText('transferSummary-step1BeneficiaryBankCity');

        return (
            <div className="beneficiary-new-bank-details">
                <div className="transfer-first-step__form-section">
                    <InputSafe
                        type="text"
                        autoComplete="off"
                        label={labelName}
                        value={this.state.name}
                        onChange={this.handleBankNameChange}
                        onBlur={this.handleBankNameBlur}
                        errorState={nameRequiredAlertVisible}
                        errorMessage={nameRequiredErrorMsg}
                        disabled={isEditingScheduled}
                    />
                </div>
                <div className="transfer-first-step__form-section">
                    <InputSafe
                        type="text"
                        autoComplete="off"
                        label={labelAddress}
                        value={this.state.address}
                        onChange={this.handleBankAddressChange}
                        onBlur={this.handleBankAddressBlur}
                        disabled={isEditingScheduled}
                    />
                </div>
                <div className="transfer-first-step__form-section">
                    <InputSafe
                        type="text"
                        autoComplete="off"
                        label={labelCity}
                        value={this.state.city}
                        onChange={this.handleBankCityChange}
                        onBlur={this.handleBankCityBlur}
                        disabled={isEditingScheduled}
                    />
                </div>
            </div>
        );
    }
}

BeneficiaryNewBankDetails.propTypes = {
    actions: PropTypes.object,
    immBeneficiaryNew: PropTypes.object,
    isEditingScheduled: PropTypes.bool
};

module.exports = BeneficiaryNewBankDetails;